import { CdkCopyToClipboard } from '@angular/cdk/clipboard';
import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { HasPermissionDirective } from '@shared/directives/has-permission.directive';
import { LOCALE_FORMAT_PIPES } from '@shared/pipes/locale-format/locale-format.pipes';
import { AppLottieModule } from './lottie.module';
import { LucideModule } from './lucide.module';
import { PrimeNGModule } from './primeng.module';

@NgModule({
	declarations: [],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		PrimeNGModule,
		CdkCopyToClipboard,
		LucideModule,
		PortalModule,
		OverlayModule,
		AppLottieModule,
		TranslocoModule,
		HasPermissionDirective,
		...LOCALE_FORMAT_PIPES,
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		PrimeNGModule,
		CdkCopyToClipboard,
		LucideModule,
		PortalModule,
		OverlayModule,
		AppLottieModule,
		TranslocoModule,
		HasPermissionDirective,
		...LOCALE_FORMAT_PIPES,
	],
})
export class SharedModule {}
